import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import AnimateHeight from 'react-animate-height';
import { useTheme } from '../hooks/useTheme.js';
import { useDisclosureContext } from './DisclosureProvider.js';

var DisclosureContent = forwardRef(function DisclosureContent(_a, ref) {
    var _b;
    var isOpenArg = _a.isOpen, idArg = _a.id, sx = _a.sx, children = _a.children, props = __rest(_a, ["isOpen", "id", "sx", "children"]);
    var _c = useTheme(), theme = _c.theme, handleStyleProps = _c.handleStyleProps;
    var context = useDisclosureContext({ optional: true });
    var isOpen = isOpenArg || context.isOpen;
    var id = idArg || context.id;
    var forwardProps = handleStyleProps({ sx: sx });
    return (jsx(AnimateHeight, __assign({ ref: ref, duration: (theme === null || theme === void 0 ? void 0 : theme.duration) && ((_b = theme === null || theme === void 0 ? void 0 : theme.duration) === null || _b === void 0 ? void 0 : _b.length) > 1
            ? parseInt(theme.duration[5])
            : 250, height: isOpen ? "auto" : 0, id: id }, forwardProps, props, { children: children })));
});

export { DisclosureContent };
//# sourceMappingURL=DisclosureContent.js.map
